<template>
  <el-dialog
    title="申报公示"
    :visible.sync="visible"
    top="29vh"
    width="600px"
    :lock-scroll="false"
    :close-on-click-modal="false"
    @close="closeDialog"
  >
    <div v-loading="isLoading">
      <el-form
        ref="ruleForm"
        class="ruleForm"
        :model="form"
        :rules="rules"
        label-position="right"
        label-width="auto"
      >
        <el-form-item label="申报公示标题" prop="name">
          <el-input
            v-model="form.name"
            placeholder="‘公示名称’+‘申报公示结果’"
            maxlength="50"
            clearable
          ></el-input>
          <p
            style="
              padding: 5px 0;
              line-height: 1.5;
              font-size: 12px;
              color: #999;
            "
          >
            样例：‘东亚数据信息服务（广东）有限公司’于2019年拟认定技术先进型服务企业
          </p>
        </el-form-item>
        <el-form-item label="完成时间" prop="completionDate">
          <el-date-picker
            v-model="form.completionDate"
            type="date"
            placeholder="请选择完成时间"
            value-format="yyyy-MM-dd"
            prefix-icon="el-icon-date"
            style="width: 100%"
          >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-date-picker>
        </el-form-item>
      </el-form>
      <p class="submit fn-text-center">
        <template v-if="projectId">
          <el-button type="primary" @click="handlerModifyData('ruleForm')"
            >修改
          </el-button>
        </template>
        <template v-else>
          <el-button type="primary" @click="handlerAddData('ruleForm')"
            >提交</el-button
          >
        </template>
      </p>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    projectId: {
      type: String,
      required: true
    }
  },
  data() {
    const isEmpty = (
      message = "该项值不能为空",
      trigger = ["blur", "change"]
    ) => {
      return {
        required: true,
        message,
        trigger
      };
    };
    return {
      visible: true,
      form: {
        name: "",
        completionDate: ""
      },
      rules: {
        name: [isEmpty("请输入单位名称")],
        completionDate: [isEmpty("请输入完成时间")]
      },
      isLoading: false
    };
  },
  created() {
    if (this.projectId) {
      this.loadInfo();
    }
  },
  methods: {
    // 关闭弹框后回调
    closeDialog() {
      // 传递关闭上一级
      this.$emit("close", true);
    },
    // 正向处理数据 将数据处理后提交
    processDataSubmit() {
      return this.form;
    },
    // 逆向处理数据 获取后进行数据处理回显
    downloadProcessData(data) {
      return data;
    },
    // 点击添加数据按钮
    handlerAddData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadAddData();
        }
      });
    },
    // 点击修改数据按钮
    handlerModifyData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadModifyData();
        }
      });
    },
    // 加载添加数据接口
    loadAddData() {
      this.isLoading = true;
      const params = this.processDataSubmit();
      this.$api("policy", "addPublicity", params).then((res) => {
        this.isLoading = false;
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.$emit("complete", true);
        }
      });
    },
    // 加载修改数据接口
    loadModifyData() {
      this.isLoading = true;
      const params = this.processDataSubmit();
      this.$api("policy", "addPublicity", {
        ...params,
        id: this.projectId
      }).then((res) => {
        this.isLoading = false;
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.$emit("complete", true);
        }
      });
    },
    // 加载数据接口
    loadInfo() {
      this.$api("policy", "getPublicityInfo", { id: this.projectId }).then(
        (res) => {
          const { code, message } = res;
          if (code === 0) {
            this.form = this.downloadProcessData(res.model);
          } else {
            this.$message.error(message);
          }
        }
      );
    }
  }
};
</script>

<style lang="less" scoped></style>
